module.exports = __webpack_public_path__ + "img/onlineCarbg3-1.4cdbf176.png";